import React from "react";
import image_1 from "../../images/smart-homes/Picture2-1.webp";

const EcoSystem = () => {
  return (
    <section className="pb-7 pt-7 bg-ghost-white" id="smart-home-eco-system">
      <div className="eco-system">
        <div className="me-13 ms-13">
          <div className="row">
            <div className="col-lg-6 col-xl-6 my-auto">
              <img src={image_1} className="img-fluid rounded" alt="" />
            </div>
            <div className="col-lg-6 col-xl-6 ps-5">
              <h1 className="fs-56 lh-64 gilroy-bold">
                The smart Home <br /> ECO
                <span className="text-orange-ryb">SYSTEM</span>
              </h1>
              <div
                style={{
                  borderBottom: "0.4rem solid #f49807",
                  width: "35%",
                  margin: "2rem 0rem",
                }}
              ></div>
              <p className="fs-20 lh-30 py-3 text-align-justify">
                Based on more sophisticated multi-dimensional products with
                state-of-the-art technology, we offer our valuable clients with
                a complete suite of several Home, Office and Educational based
                automation products ranging from Audio Visual, Home Cinema, CCTV
                Video Surveillance, Digital Signage, Video Conferencing and Fire
                Alarm Systems to Fiber Optic, Networking Designs and Parking
                Management systems.
              </p>
              <ul className="fs-20 gilroy-bold">
                <li>Functionality First</li>
                <li>Making a Better Smart Home</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcoSystem;
